class upsellBundle extends HTMLElement {
  constructor() {
    super();
    this.body = document.querySelector('body');
    this.submitButton = this.querySelector('.cart__upgrade-button');
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    this.init();
  }

  init(){
    this.submitButton.addEventListener('click', this.handleSubmit.bind(this));
  }

  handleSubmit(event) {
    event.preventDefault();
    this.submitButton.setAttribute('aria-disabled', true);
    this.submitButton.classList.add('loading');

    console.log(this.submitButton.getAttribute('data-variant-ids'));
  
    const variantIds = this.submitButton.getAttribute('data-variant-ids').split(',');
  
    let finalformData = {
      'items': variantIds.filter((id) => id !== '').map((id) => ({
        'id': parseInt(id, 10),
        'quantity': 1
      }))
    };
  
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(finalformData)
    })
    .then((response) => response.json())
    .then((response) => {
      this.fetchCart();
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      console.log("is there error?")  
      this.submitButton.classList.remove('loading');
    });
  }

  fetchCart() {

      fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const cartDrawerContent = html.querySelector('.cart-drawer');
        const targetCartDrawer = document.querySelector('.cart-drawer');
        if (cartDrawerContent && targetCartDrawer) {
          targetCartDrawer.innerHTML = cartDrawerContent.innerHTML;
        }
        this.cart.classList.remove('is-empty');
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.cart.classList.add('animate', 'active');
        this.submitButton.setAttribute('aria-disabled', false);
        this.body.classList.add('overflow-hidden');
      });

      fetch(`${routes.cart_url}?section_id=cart-icon-bubble`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const cartIconBubble = html.querySelector('.shopify-section'); // Select the element with class cart-icon-bubble
        const targetIconBubble = document.querySelector('#cart-icon-bubble');
        if (cartIconBubble && targetIconBubble) {
          targetIconBubble.innerHTML = cartIconBubble.innerHTML;
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
      });
  }


}

customElements.define('upsell-bundle', upsellBundle);